import authBaseAxios from "../utils/api";

export const AuthServices = {
  logIn: (body: any) => {
    return authBaseAxios.post("auth/login", body);
  },
  logOut: () => {
    return authBaseAxios.post("auth/logout");
  },
};
